const getters = {
  accessToken: state => state.user.accessToken,
  userType: state => state.user.userType,
  type: state => state.user.type,
  loginSource: state => state.user.loginSource,
}
export default getters
